import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

export const fetchPDDAppIDRFWPhy = createAsyncThunk(
    'fetchPDDAppIDRFWPhy',
    async ({ jwtBearer }) => {
        const response = await fetch(`${BASE_URL}pdd/get/app/id/rfw/phy/`, {
            headers: {
                Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
            }
        })
        return response.json()
    }
)

const pddDataRFWPhySlice = createSlice({
    name: 'pddDataRFWSlice',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: builder => {
        builder.addCase(fetchPDDAppIDRFWPhy.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchPDDAppIDRFWPhy.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        })
        builder.addCase(fetchPDDAppIDRFWPhy.rejected, (state, action) => {
            console.log('Error', action.payload)
            state.isError = true
        })
    }
})

export default pddDataRFWPhySlice.reducer
